import {SignedIn, SignedOut, SignIn, SignUp, useUser} from '@clerk/clerk-react'
import {useEffect} from 'react'
import {identifyUser} from '@/lib/clarity'

interface AuthWrapperProps {
	children: React.ReactNode
}

export function AuthWrapper({children}: AuthWrapperProps) {
	const {user} = useUser()

	useEffect(() => {
		if (user?.id) {
			identifyUser(
				user.id,
				undefined,
				undefined,
				user.fullName || user.primaryEmailAddress?.emailAddress || undefined,
			)
		}
	}, [user?.id, user?.fullName, user?.primaryEmailAddress?.emailAddress])

	// Clerk appends `__clerk_ticket` + `__clerk_status` when it redirects an
	// invitation link to the app. A brand-new invitee has no existing sign-in
	// identification, so the ticket must be handed to <SignUp /> (whose ticket
	// strategy CREATES the identification). Routing it to <SignIn /> yields
	// "This invitation refers to a non-existing identification". Already-registered
	// invitees arrive with __clerk_status=sign_in and stay on <SignIn />.
	const params = new URLSearchParams(window.location.search)
	const isSignUpTicket =
		params.get('__clerk_status') === 'sign_up' ||
		(params.has('__clerk_ticket') && params.get('__clerk_status') !== 'sign_in')

	return (
		<div>
			<SignedOut>
				<div className='flex h-screen items-center justify-center'>
					{isSignUpTicket ? <SignUp /> : <SignIn />}
				</div>
			</SignedOut>

			<SignedIn>{children}</SignedIn>
		</div>
	)
}
